import DefaultRenderer from './default';
import form from '../../components/form';

class selfApplication extends DefaultRenderer {
	onEnter() {
		super.onEnter();

		// Get Scroll Instance
		let mainScroll = this.mainController.getScroll();

		// Submit Form
		form(mainScroll);
	}

	onLeave() {
		super.onLeave();
	}

	onEnterCompleted() {
		super.onEnterCompleted();
	}
}

export default selfApplication;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/selfApplication.js